import firebaseService from 'utils/firebase/firebase';
import {setRemoteConfigLoaded} from './actions';

// firebaseService.remoteConfig is the RNFirebase-shaped facade; its
// fetchAndActivate() wraps the modular fetchAndActivate(rcInstance) call.
export const initRemoteConfig = () => {
  return async (dispatch) => {
    console.log('[WEBGL_DBG] RC fetchAndActivate START');
    firebaseService.remoteConfig
      .fetchAndActivate()
      .then((activated) => {
        console.log('[WEBGL_DBG] RC fetchAndActivate DONE activated=' + activated);
        dispatch(setRemoteConfigLoaded());
      })
      .catch((err) => {
        console.error('[WEBGL_DBG] RC fetchAndActivate FAILED — proceeding with defaults', err);
        dispatch(setRemoteConfigLoaded());
      });
  };
};
